import { useCallback, type FC, type PropsWithChildren } from 'react';
import { AuthProvider as OriginalOAuthProvider } from 'react-oidc-context';

import { authProviderConfig } from '#apps/client-web/features/auth/config/oidc';

export const AuthProvider: FC<PropsWithChildren> = ({ children }) => {
  // Clear auth params from URL after sign-in to prevent repeated processing
  const signInCallback = useCallback(() => {
    window.history.replaceState({}, document.title, window.location.pathname);
  }, []);

  return (
    <OriginalOAuthProvider
      {...authProviderConfig}
      onSigninCallback={signInCallback}>
      {children}
    </OriginalOAuthProvider>
  );
};
